export default "__VITE_ASSET__CIrlmLdN__"